// Import external libraries
import axios from "axios";

// Import config helper
import config from "../utility/config";

// Set axios defaults
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["accept-language"] = config.defaultLanguage;

// https://rest-eu-qs.mcs2.miele.com/cooking/v2
// https://rest-eu.mcs.miele.com/cooking/v2
// https://api-eu.qs.mcs3.miele.com/cooking/v2
// https://api-eu.mcs3.miele.com/cooking/v2

// Set Api values
// const baseURL = 'https://cdn.api.miele.com/cooking/v2/';
const baseURL = config.baseUrl || "https://cdn.api.miele.com/cooking/v2/";

export default () => {
  return axios.create({
    baseURL,
  });
};
